import React from 'react';
import {Translation, withTranslation, WithTranslation} from 'react-i18next';
import {useLoaderData} from "react-router-dom";
import ArticleIntro from "./ArticleIntro";
import {ArticleIntro as ArticleIntroModel} from "./model/Article";
import {getApi} from "./api/Api";

interface LoaderParams {
    page?: number,
    pageSize?: number
}

interface LoaderArgs {
    params: LoaderParams
}

export async function loader(loaderArgs: LoaderArgs) {
    const api = getApi()
    let page = loaderArgs.params?.page
    if (!page) page = 0

    let pageSize = loaderArgs.params?.pageSize
    if (!pageSize) pageSize = 10

    const articleIntros = await api.getArticleIntros(pageSize, page * pageSize)
    return {articleIntros};
}

const ArticleIntroList = (props: ArticleIntroListProps) => {
    const {articleIntros} = useLoaderData() as { articleIntros: ArticleIntroModel[] };
    return (
        <Translation>
            {t =>
                <div className="container-xxl">
                    {
                        articleIntros.map((articleIntro, index) => (
                            <ArticleIntro key={articleIntro.id} id={articleIntro.id}
                                          title={articleIntro.title}
                                          text={articleIntro.introText}
                                          publishTimeMillisUtc={articleIntro.publishTimeMillisUtc}
                            />
                        ))
                    }
                </div>
            }
        </Translation>
    )
}

interface ArticleIntroListProps extends WithTranslation {
    page?: number;
    pageSize?: number;
}

export default withTranslation()(ArticleIntroList)

